import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import * as _ from "lodash";

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css']
})
export class SelectComponent implements OnInit {

  id: any;
  @Input() label: string = "";
  @Input() options: any[];
  selected: any;
  @Output() onSelectedOut = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
    this.id = 'select-' + _.random(100, 8000);
    //console.log(this.id + "init select change: " + this.selected);
  }

  onChange(evt) {
    console.log(this.id + " select change: " + evt);
    /*console.log(this.id+" select change: "+JSON.stringify(evt));
    console.log(this.id+" select change: "+this.selected);
    console.log(this.id+" select change: "+JSON.stringify(this.selected));*/
    if (evt != 0) {
      this.selected = evt;
      this.onSelectedOut.emit(evt);
    }
  }

}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/select/select.component.ts